import axios from 'src/api/Api';
import {
    SEND_USAGE_REPORT_SUCCESS,
    SEND_USAGE_REPORT_FAILURE,
	RESET_SEND_USAGE_REPORT_STATUS,
} from 'src/pages/orders/redux/actions';
import { put,delay } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* sendReportSaga(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/reports`;
    try {
        const result = yield axios
            .post(url, action.payload)
            .then((response) => response.data);
        yield put({ type: SEND_USAGE_REPORT_SUCCESS, data: result });
		yield delay(1500);
		yield put({ type: RESET_SEND_USAGE_REPORT_STATUS, payload: {statusCode: '',isSendReportReset: true} });
		yield delay(500);
		yield put({ type: RESET_SEND_USAGE_REPORT_STATUS, payload: {isSendReportReset: false} });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SEND_USAGE_REPORT_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
